// extracted by mini-css-extract-plugin
module.exports = {"teams":"kqaHY","team":"_1CM93","fadeIn":"_2Up6o","homeTeam":"cq9ip","awayTeam":"_39763","teamName":"-CS7T","teamImg":"_3Q1V4","teamsSeparator":"_3agYm"};